import { useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import EvidenceModal from "./EvidenceModal";

export default function PdfModalApp({ certificatePath, courseName }) {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);
  return (
    <>
      <button
        type="button"
        className="evidence-trigger"
        onClick={() => setShow(true)}
      >
        {t("certificates.viewCertificate")}
      </button>
      <EvidenceModal
        show={show}
        onHide={() => setShow(false)}
        title={courseName}
        wide
      >
        <div className="evidence-toolbar">
          <span>{t("evidence.pdf")}</span>
          <div className="evidence-actions">
            <a href={certificatePath} target="_blank" rel="noreferrer">
              {t("evidence.open")}
            </a>
            <a href={certificatePath} download>
              {t("evidence.download")}
            </a>
          </div>
        </div>
        <iframe
          src={certificatePath}
          title={t("certificates.pdfViewer")}
          className="certificate-preview"
          allowFullScreen
        />
        <p className="evidence-hint">{t("evidence.pdfHint")}</p>
      </EvidenceModal>
    </>
  );
}
